import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/District/add'
import { v3_add_district, v3_add_state } from '../../../actions/v3/masterData'
import constant from '../../../constant'
import { toast } from 'react-toastify'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_district(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listDistrictMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Master Data'}
            >
                <Form
                    title={'Add City'}
                    onSubmit={onSubmit}
                    buttonName={'Create City'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add